export const INTERSECTION_API_CONFIG = {
  root: null,
  rootMargin: '0px',
  threshold: 1.0,
};
